import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

export default class extends Controller {
  static targets = [
    'company',
    'role',
    'countryLimitContainer',
    'submitButton',
    'spinner',
  ]
  static values = {
    path: { type: String, default: '/advantage_invitations/countries' },
  }

  connect() {
    this.lastRoleValue = this.hasRoleTarget ? this.roleTarget.value : ''
  }

  async updateCountries(event) {
    const companyId = this.hasCompanyTarget ? this.companyTarget.value : ''
    const role = this.hasRoleTarget ? this.roleTarget.value : ''
    const previousRole = this.lastRoleValue
    const isRoleChange = event?.currentTarget === this.roleTarget
    const showsCountriesBefore = this.showsCountriesForRole(previousRole)
    const showsCountriesAfter = this.showsCountriesForRole(role)

    this.lastRoleValue = role

    if (companyId === '' || !showsCountriesAfter) {
      this.countryLimitContainerTarget.innerHTML = ''
      return
    }

    if (isRoleChange && showsCountriesBefore && showsCountriesAfter) return

    const params = new URLSearchParams({ company_id: companyId })
    this.selectedCountryCodes().forEach((countryCode) =>
      params.append('country_codes[]', countryCode),
    )

    try {
      this.setLoadingState(true)
      const response = await fetch(`${this.pathValue}?${params.toString()}`, {
        headers: {
          Accept: 'text/vnd.turbo-stream.html',
        },
      })

      if (
        !response.ok ||
        !(response.headers.get('content-type') || '').includes(
          'text/vnd.turbo-stream.html',
        )
      ) {
        console.error('Failed to fetch countries', response.status)
        return
      }

      Turbo.renderStreamMessage(await response.text())
    } catch (error) {
      console.error('Failed to fetch countries', error)
      return
    } finally {
      this.setLoadingState(false)
    }
  }

  selectedCountryCodes() {
    return Array.from(
      this.countryLimitContainerTarget.querySelectorAll(
        'input[name*="[country_codes][]"]:checked',
      ),
    ).map((input) => input.value)
  }

  setLoadingState(isLoading) {
    if (this.hasRoleTarget) {
      this.roleTarget.disabled = isLoading
      this.roleTarget.setAttribute('aria-busy', String(isLoading))
    }

    this.submitButtons().forEach((button) => {
      button.disabled = isLoading
      button.setAttribute('aria-busy', String(isLoading))
    })

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.toggle('hidden', !isLoading)
      this.spinnerTarget.style.display = isLoading ? '' : 'none'
      this.spinnerTarget.setAttribute('aria-hidden', String(!isLoading))
    }
  }

  submitButtons() {
    const scopedButtons = [...this.submitButtonTargets]
    const modalContent = this.element.closest('.modal-content')

    if (!modalContent) return scopedButtons

    const footerButtons = [
      ...modalContent.querySelectorAll('.modal-footer input[type="submit"]'),
    ]
    return [...new Set([...scopedButtons, ...footerButtons])]
  }

  showsCountriesForRole(role) {
    return role !== '' && role !== 'owner_role'
  }
}
